import { H4 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EnrollmentChecksSection from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/EnrollmentChecksSection';
import UILink from 'UIComponents/link/UILink';
import { getRevisionUrl } from 'flow-doctor-lib/utils/urls';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentValidationChecksView = ({
  validationChecksByStatus,
  flowRevision,
  objectId,
  timelineItem
}) => {
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "800",
    as: "div",
    children: [/*#__PURE__*/_jsx(H4, {
      "aria-level": 3,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.title"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "300",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.description"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "600",
      as: "div",
      children: /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: getRevisionUrl({
          portalId: flowRevision.portalId,
          flowId: flowRevision.flowId,
          version: flowRevision.version,
          isEventTriggers: flowRevision.flow.enrollmentTrigger === 'EVENT'
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.revisionAtTime"
        })
      })
    }), /*#__PURE__*/_jsx(EnrollmentChecksSection, {
      status: "FAILED",
      flowRevision: flowRevision,
      validationChecks: validationChecksByStatus.failed,
      objectId: objectId,
      timelineItem: timelineItem
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(EnrollmentChecksSection, {
      status: "PASSED",
      flowRevision: flowRevision,
      validationChecks: validationChecksByStatus.passed,
      objectId: objectId,
      timelineItem: timelineItem
    })]
  });
};
export default EnrollmentValidationChecksView;